import _ from "lodash";
import moment from 'moment';
const reducers = {

  // ======================GENERIC======================//

  ERROR: (state, { error, code }) => {
    console.error(error);
    return {
      ...state,
      error: { code, exist: true, message: error }
    };
  },

  SET_SIDEBAR_RIGHT: (state, payload) => {
    return {
      ...state,
      isSidebarRightOpen: !state.isSidebarRightOpen
    };
  },

  // ======================SPECIALITIES======================//
  GET_SPECIALITIES: (state, payload) => {
    const reversed = _.cloneDeep(payload.specialities).reverse();
    return {
      ...state,
      specialties: reversed
      // specialties: payload.specialities
    };
  },

  CREATE_SPECIALTY: (state, payload) => {
    return {
      ...state,
      specialties: [payload.result, ...state.specialties]
    };
  },

  EDIT_SPECIALTY: (state, payload) => {
    const { result } = payload
    const specialtiesArray = [...state.specialties]
    const index = state.specialties.findIndex(data => data._id === result._id);
    specialtiesArray[index] = result
    return {
      ...state,
      specialties: specialtiesArray,
      selectedSpeciality: result
    };
  },

  DELETE_SPECIALTY: (state, payload) => {
    return {
      ...state,
      specialties: state.specialties.filter(specialty => specialty._id !== payload.speciality),
      //rest values of the sidebar
      selectedSpeciality: null,
    };
  },

  SET_SELECTED_SPECIALITY: (state, payload) => {
    return {
      ...state,
      selectedSpeciality: payload.specialityData
    };
  },

  // ======================SUB-SPECIALITIES======================//
  // GET_SUB_SPECIALITIES: (state, payload) => {
  //   return {
  //     ...state,
  //     subSpecialities: payload.specialities
  //   };
  // },

  SET_SELECTED_SUB_SPECIALITIES: (state, payload) => {
    return {
      ...state,
      selectedSubSpeciality: payload.subSpecialityData
    };
  },

  CREATE_SUB_SPECIALTY: (state, payload) => {

    //clone of the actual specialits
    const specialtiesArr = state.specialties.map(a => ({ ...a }));

    for (let i = 0; i < specialtiesArr.length; i++) {
      if (specialtiesArr[i]._id === payload.result.specialityId) {
        let subSpecialtiesArr = state.specialties[i]?.subspecialities ? state.specialties[i].subspecialities.map(a => ({ ...a })) : []
        subSpecialtiesArr.push(payload.result)
        specialtiesArr[i].subspecialities = subSpecialtiesArr
      }
    }

    return {
      ...state,
      specialties: specialtiesArr
    };
  },

  EDIT_SUB_SPECIALTY: (state, payload) => {
    const { subspeciality } = payload
    const specialtiesArray = state.specialties.map(a => ({ ...a }));

    for (let i = 0; i < specialtiesArray.length; i++) {
      if (specialtiesArray[i]._id === subspeciality.specialityId) {
        let subSpecialtiesArray = state.specialties[i].subspecialities.map(a => ({ ...a }));
        const index = subSpecialtiesArray.findIndex(data => data._id === subspeciality._id);
        subSpecialtiesArray[index] = subspeciality
        specialtiesArray[i].subspecialities = subSpecialtiesArray
      }
    }

    return {
      ...state,
      specialties: specialtiesArray,
      selectedSubSpeciality: subspeciality
    };
  },

  DELETE_SUB_SPECIALTY: (state, payload) => {
    const arraySpecialties = state.specialties.map(a => ({ ...a }));

    for (let i = 0; i < arraySpecialties.length; i++) {
      if (state.specialties[i]._id === state.selectedSpeciality._id) {
        const subSpecialtiesArr = state.specialties[i].subspecialities.filter(subData => subData._id !== payload.subspeciality)
        arraySpecialties[i].subspecialities = subSpecialtiesArr
      }
    }

    return {
      ...state,
      specialties: arraySpecialties,
      //rest values of the sidebar
      selectedSpeciality: null,
      selectedSubSpeciality: null,
      isSidebarRightOpen: false
    };
  },

  // ------------------ CLINICAL CASE-------------//

  RESET_CLINICAL_CASE: (state) => {
    return {
      ...state,
      selectedClinicalCase: null,
      loadingClinicalCase: true,
      isEditActive: false,
    };
  },

  SET_SELECTED_CLINICAL_CASE: (state, payload) => {
    return {
      ...state,
      selectedClinicalCase: payload.clinicalCaseData,
      loadingClinicalCase: false,
      isEditActive: false,
    };
  },

  GET_CLINICAL_CASES: (state, payload) => {
    // const cloneArrayCases = _.cloneDeep(payload.clinicalcases)
    // const sortedClinicalCases = cloneArrayCases.sort((a, b) => moment(b.dateCreated) - moment(a.dateCreated))
    const reversed = _.cloneDeep(payload.clinicalcases).reverse();
    return {
      ...state,
      clinicalCases: reversed
      // clinicalCases: sortedClinicalCases
      // clinicalCases: payload.clinicalcases
    };
  },

  SET_FILTERS_CLINICAL_CASES: (state, payload) => {
    const { filters, resultAll } = payload.filtersRes
    return {
      ...state,
      clinicalCasesFilters: resultAll,
      activeFilters: filters
    };
  },

  RESET_FILTERS: (state) => {
    return {
      ...state,
      clinicalCasesFilters: [],
      activeFilters: null,
    };
  },

  NEW_CLINICAL_CASE: (state, payload) => {
    return {
      ...state,
      selectedClinicalCase: payload.newCase,
      loadingClinicalCase: false,
      isEditActive: false,
    };
  },

  DELETE_CLINICAL_CASE: (state, payload) => {
    return {
      ...state,
      selectedClinicalCase: null,
      clinicalCases: state.clinicalCases.filter((data) => data._id !== payload.clinicalcase),
      isEditActive: false,
    };
  },

  EDIT_CLINICAL_CASE: (state, payload) => {
    console.log("_editar_caso")
    console.log(payload)
    console.log("_editar_caso")
    let arrayCases = [...state.clinicalCases]
    let indexCase = arrayCases.findIndex(obj => obj._id === state.selectedClinicalCase._id)
    arrayCases[indexCase] = payload.clinicalcases[0]

    //if filters are active
    let arrayCasesFilters = [...state.clinicalCasesFilters]
    if (state.clinicalCasesFilters.length > 0) {
      let indexCase = arrayCasesFilters.findIndex(obj => obj._id === state.selectedClinicalCase._id)
      arrayCasesFilters[indexCase] = payload.clinicalcases[0]
    }

    return {
      ...state,
      selectedClinicalCase: payload.clinicalcases[0],
      clinicalCases: payload?.isNew ? [payload.clinicalcases[0], ...state.clinicalCases] : arrayCases,
      clinicalCasesFilters: payload?.isNew && state.activeFilters ?
        [payload.clinicalcases[0], ...state.clinicalCasesFilters] : state.clinicalCasesFilters.length > 0 ? arrayCasesFilters : [],
      isEditActive: false,
    };
  },

  ADD_IMAGES: (state, payload) => {
    console.log("Reducer_image_ADD")
    console.log(payload)
    console.log("Reducer_image_ADD")

    switch (payload.typeImage) {
      case 1: //clinicalCase image
        const deepCopySelectedClinicalCase = _.cloneDeep(state.selectedClinicalCase)
        deepCopySelectedClinicalCase.imgFile.push(payload.image)
        // deepCopySelectedClinicalCase.imgFile.push(payload.image.url)

        return {
          ...state,
          selectedClinicalCase: {
            ...state.selectedClinicalCase,
            imgFile: deepCopySelectedClinicalCase.imgFile
          },
          isEditActive: true,
        };
      case 2://clinicalCase question[n] image
        const deepCopyIdQuestions = _.cloneDeep(state.selectedClinicalCase.idQuestions)

        if (Array.isArray(deepCopyIdQuestions[payload.tempIndex - 1].imgFile)) {
          deepCopyIdQuestions[payload.tempIndex - 1].imgFile.push(payload.image)
        } else {
          let newArray = []
          newArray.push(payload.image)
          deepCopyIdQuestions[payload.tempIndex - 1].imgFile = newArray
        }

        return {
          ...state,
          selectedClinicalCase: {
            ...state.selectedClinicalCase,
            idQuestions: deepCopyIdQuestions
          },
          isEditActive: true,
        };
      case 3://clinicalCase answer[n] image
        const { tempIndex, image, tempIdAnswer } = payload
        const IdQuestionsClone = _.cloneDeep(state.selectedClinicalCase.idQuestions)
        delete IdQuestionsClone[tempIndex - 1].idAnswers[tempIdAnswer].answerText
        // IdQuestionsClone[tempIndex - 1].idAnswers[tempIdAnswer].answerText = ""
        IdQuestionsClone[tempIndex - 1].idAnswers[tempIdAnswer].typeAnswer = 2
        IdQuestionsClone[tempIndex - 1].idAnswers[tempIdAnswer].imgFile.push(image)

        return {
          ...state,
          selectedClinicalCase: {
            ...state.selectedClinicalCase,
            idQuestions: IdQuestionsClone
          },
          isEditActive: true,
        };

      default:
        return {
          ...state,
        };
    }
  },

  DELETE_IMAGES: (state, payload) => {
    console.log("BOrrar")
    console.log(payload)
    console.log("BOrrar")
    const { paginationState, typeImage, idImage, tempId } = payload.objImage
    switch (typeImage) {
      case 1: //clinicalCase image
        const deepCopySelectedClinicalCase = _.cloneDeep(state.selectedClinicalCase)
        let newArray = deepCopySelectedClinicalCase.imgFile.filter((data) => data._id !== idImage)
        return {
          ...state,
          selectedClinicalCase: {
            ...state.selectedClinicalCase,
            imgFile: newArray
          },
          isEditActive: true,
        };
      case 2://clinicalCase question[n] image
        const deepCopyIdQuestions = _.cloneDeep(state.selectedClinicalCase.idQuestions)
        let arrayQuestions = deepCopyIdQuestions[paginationState - 1].imgFile.filter((data) => data._id !== idImage)
        deepCopyIdQuestions[paginationState - 1].imgFile = arrayQuestions;

        return {
          ...state,
          selectedClinicalCase: {
            ...state.selectedClinicalCase,
            idQuestions: deepCopyIdQuestions
          },
          isEditActive: true,
        };
      case 3://clinicalCase answer image
        const cloneQuestionsArray = _.cloneDeep(state.selectedClinicalCase.idQuestions)
        let array = cloneQuestionsArray[paginationState - 1].idAnswers[tempId].imgFile.filter((data) => data._id !== idImage)
        cloneQuestionsArray[paginationState - 1].idAnswers[tempId].imgFile = array;

        return {
          ...state,
          selectedClinicalCase: {
            ...state.selectedClinicalCase,
            idQuestions: cloneQuestionsArray
          },
          isEditActive: true,
        };
      default:
        return {
          ...state,
        };
    }
  },

  SET_STATUS: (state, payload) => {
    console.log("VER_languageStatus")
    console.log(payload)
    console.log("VER_languageStatus")
    // let arrayClinicalCases = _.cloneDeep(state.clinicalCases)
    // let indexCase = arrayClinicalCases.findIndex(obj => obj._id === state.selectedClinicalCase._id)
    // arrayClinicalCases[indexCase].inEnglish = payload.languageStatus

    const { typeStatus, value } = payload.objStatus
    switch (typeStatus) {
      case "ingles":
        return {
          ...state,
          selectedClinicalCase: {
            ...state.selectedClinicalCase,
            inEnglish: value
          },
          isEditActive: true,
        };
      case "revision":
        return {
          ...state,
          selectedClinicalCase: {
            ...state.selectedClinicalCase,
            needReview: value
          },
          isEditActive: true,
        };
      case "validado":
        return {
          ...state,
          selectedClinicalCase: {
            ...state.selectedClinicalCase,
            isValidated: value
          },
          isEditActive: true,
        };
      default:
        return {
          ...state,
        };
    }
  },

  EDIT_CLINICAL_TEXT: (state, payload) => {
    return {
      ...state,
      selectedClinicalCase: {
        ...state.selectedClinicalCase,
        clinicalText: payload.text
      },
      isEditActive: true,
    };
  },

  ADD_REFERENCE: (state, payload) => {
    console.log("VER_add_ref")
    console.log(payload)
    console.log("VER_add_ref")
    return {
      ...state,
      selectedClinicalCase: {
        ...state.selectedClinicalCase,
        references: [...state.selectedClinicalCase.references, payload.textReference]
      },
      isEditActive: true,
    };
  },

  EDIT_REFERENCE: (state, payload) => {
    const { index, text } = payload.textReference
    const copyReferences = _.cloneDeep(state.selectedClinicalCase.references)
    copyReferences[index] = text

    return {
      ...state,
      selectedClinicalCase: {
        ...state.selectedClinicalCase,
        references: copyReferences
      },
      isEditActive: true,
    };
  },

  DELETE_REFERENCE: (state, payload) => {
    console.log("REDUCER_delete_ref")
    console.log(payload)
    console.log("REDUCER_delete_ref")
    const arrayReferences = _.cloneDeep(state.selectedClinicalCase.references)
    arrayReferences.splice(payload.idReference, 1);

    return {
      ...state,
      selectedClinicalCase: {
        ...state.selectedClinicalCase,
        references: arrayReferences
      },
      isEditActive: true,
    };
  },

  ADD_COMMENT: (state, payload) => {
    console.log("payload_ADDCOMMENT")
    console.log(payload)
    console.log("payload_ADDCOMMENT")
    return {
      ...state,
      selectedClinicalCase: {
        ...state.selectedClinicalCase,
        comments: [...state.selectedClinicalCase.comments, payload.commentObj]
      },
      isEditActive: true,
    };
  },

  EDIT_COMMENT: (state, payload) => {
    console.log("payload_EDIT_comment")
    console.log(payload)
    console.log("payload_EDIT_comment")
    const { index, comment } = payload.objEditComment
    const cloneComents = _.cloneDeep(state.selectedClinicalCase.comments)
    cloneComents[index].comment = comment
    return {
      ...state,
      selectedClinicalCase: {
        ...state.selectedClinicalCase,
        comments: cloneComents
      },
      isEditActive: true,
    };
  },

  DELETE_COMMENT: (state, payload) => {

    const arrayComments = _.cloneDeep(state.selectedClinicalCase.comments)
    arrayComments.splice(payload.indexToDelete, 1);
    return {
      ...state,
      selectedClinicalCase: {
        ...state.selectedClinicalCase,
        comments: arrayComments
      },
      isEditActive: true,
    };
  },

  // ------------------ QUESTIONS-------------//

  ADD_QUESTION: (state, payload) => {
    const deepCopyIdQuestions = _.cloneDeep(state.selectedClinicalCase.idQuestions)
    deepCopyIdQuestions.push(payload.newArrayQuestions)
    return {
      ...state,
      selectedClinicalCase: {
        ...state.selectedClinicalCase,
        idQuestions: deepCopyIdQuestions
      },
      isEditActive: true,
    };
  },

  DELETE_QUESTION: (state, payload) => {
    const deepCopySelectedClinicalCase = _.cloneDeep(state.selectedClinicalCase)
    deepCopySelectedClinicalCase.idQuestions.splice(payload.paginationState - 1, 1)
    return {
      ...state,
      selectedClinicalCase: deepCopySelectedClinicalCase,
      isEditActive: true,
    };
  },

  STATUS_QUESTION_LANGUAGE: (state, payload) => {
    const { value, paginationState } = payload.objStatusQuestion
    const deepCopyIdQuestions = _.cloneDeep(state.selectedClinicalCase.idQuestions)
    deepCopyIdQuestions[paginationState - 1].inEnglish = value;

    return {
      ...state,
      selectedClinicalCase: {
        ...state.selectedClinicalCase,
        idQuestions: deepCopyIdQuestions
      },
      isEditActive: true,
    };
  },

  EDIT_QUESTION: (state, payload) => {
    const { value, paginationState } = payload.objQuestion
    const deepCopyIdQuestions = _.cloneDeep(state.selectedClinicalCase.idQuestions)
    deepCopyIdQuestions[paginationState - 1].textQuestion = value;

    return {
      ...state,
      selectedClinicalCase: {
        ...state.selectedClinicalCase,
        idQuestions: deepCopyIdQuestions
      },
      isEditActive: true,
    };
  },

  EDIT_QUESTION_JUSTIFICATION: (state, payload) => {
    const { value, paginationState } = payload.objJustification
    const deepCopyIdQuestions = _.cloneDeep(state.selectedClinicalCase.idQuestions)
    deepCopyIdQuestions[paginationState - 1].justification = value;

    return {
      ...state,
      selectedClinicalCase: {
        ...state.selectedClinicalCase,
        idQuestions: deepCopyIdQuestions
      },
      isEditActive: true,
    };
  },

  // ------------------ ANSWERS-------------//

  ADD_ANSWER: (state, payload) => {
    const { answerTemplate, paginationState } = payload.obj
    const deepCopyIdQuestions = _.cloneDeep(state.selectedClinicalCase.idQuestions)
    deepCopyIdQuestions[paginationState - 1].idAnswers.push(answerTemplate)

    return {
      ...state,
      selectedClinicalCase: {
        ...state.selectedClinicalCase,
        idQuestions: deepCopyIdQuestions
      },
      isEditActive: true,
    };
  },

  EDIT_ANSWER: (state, payload) => {
    const { paginationState, tempId, value } = payload.objAnswer
    const deepCopyIdQuestions = _.cloneDeep(state.selectedClinicalCase.idQuestions)
    deepCopyIdQuestions[paginationState - 1].idAnswers[tempId].answerText = value;

    return {
      ...state,
      selectedClinicalCase: {
        ...state.selectedClinicalCase,
        idQuestions: deepCopyIdQuestions
      },
      isEditActive: true,
    };
  },

  CORRECT_ANSWER: (state, payload) => {
    // console.log(payload)
    const { paginationState, status, tempIdAnswer } = payload.objAnswer
    const deepCopyIdQuestions = _.cloneDeep(state.selectedClinicalCase.idQuestions)
    deepCopyIdQuestions[paginationState - 1].idAnswers[tempIdAnswer].isCorrect = status;

    return {
      ...state,
      selectedClinicalCase: {
        ...state.selectedClinicalCase,
        idQuestions: deepCopyIdQuestions
      },
      isEditActive: true,
    };
  },

  DELETE_ANSWER: (state, payload) => {
    console.log("BOrar_respuesta")
    console.log(payload)
    console.log("BOrar_respuesta")
    const deepCopyWithLodashCloneDeep = _.cloneDeep(state.selectedClinicalCase.idQuestions)
    const { idAnswer, paginationState } = payload.objAnswer

    deepCopyWithLodashCloneDeep[paginationState - 1].idAnswers.splice(idAnswer, 1);

    return {
      ...state,
      selectedClinicalCase: {
        ...state.selectedClinicalCase,
        idQuestions: deepCopyWithLodashCloneDeep
      },
      isEditActive: true,
    };
  },

}
export default reducers;